import React from 'react';
import { css } from '@emotion/react';
import { Trans } from '@lingui/macro';

import { VotesUpIcon } from '$/images/Icons';

export const FeaturedOnProductHunt: React.FC<{
  size: 'modal' | 'card';
  onClick?: () => void;
  votes?: number | null;
}> = ({ size, votes, onClick }) => {
  const baseSize = size === 'modal' ? 1 : 0.75;

  return (
    <div
      className='flex justify-between items-center w-full'
      css={css`
        position: relative;
        background-color: #eb491a;
        width: calc(100% + 2rem);
        text-color: #fff;
        font-weight: 700;
        font-family:
          -apple-system,
          BlinkMacSystemFont,
          Segoe UI,
          Helvetica,
          Arial,
          sans-serif;
      `}
      onClick={(): void => {
        onClick && onClick();
      }}
    >
      <div className='flex items-center'>
        <img
          src={require('./media/producthunt.png').default}
          css={css`
            margin-right: ${baseSize}rem;
            width: ${baseSize * 4}rem;
          `}
        />
        <div className='flex flex-col leading-none'>
          <div
            css={css`
              font-size: ${baseSize}rem;
            `}
          >
            <Trans>FEATURED ON</Trans>
          </div>
          <div
            css={css`
              font-size: ${baseSize * 2.125}rem;
            `}
          >
            Product Hunt
          </div>
        </div>
      </div>
      {votes != null && (
        <div className='flex flex-col items-center min-w-4e'>
          <div className='flex'>
            <VotesUpIcon
              css={css`
                height: ${baseSize}rem;
              `}
            />
          </div>
          <div
            className='flex'
            css={css`
              font-size: ${baseSize * 1.125}rem;
              margin-top: ${baseSize * 0.5}rem;
            `}
          >
            {votes ?? '...'}
          </div>
        </div>
      )}
    </div>
  );
};
